import React, { Component } from "react";
import { Input } from "reactstrap";
import { SERVER_URL } from "../constants/variables";
import { getAuthHeaders, getEntityId, getUserRoleId } from "../utils/api";
import Sidebar from "./Sidebar";
import toast from "react-hot-toast";
import "./ResetPasswordComponent.css";

const PWD_REGEX = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|":<>[\]\\' ~_]).{8,}/;

class ResetPasswordComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      user: {},
      tabs: [],
      idRoleMap: {},
      newPassword: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  getEmail = () => {
    const u = this.state.user?.user;
    return u?.user?.email ?? u?.email;
  };

  submitResetPassword = () => {
    const { newPassword } = this.state;
    const email = this.getEmail();
    if (!newPassword.trim()) {
      toast.error("Please enter a password");
      return;
    }
    if (!PWD_REGEX.test(newPassword)) {
      toast.error("Password should satisfy the criteria below");
      return;
    }
    if (!email) {
      toast.error("Session expired. Please log in again.");
      return;
    }
    toast.loading("Updating…", { duration: 2000 });
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const authHeaders = getAuthHeaders();
    if (authHeaders.Authorization) myHeaders.append("Authorization", authHeaders.Authorization);

    fetch(SERVER_URL + "/users/resetpassword", {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ email, password: newPassword }),
      redirect: "follow",
    })
      .then((res) => res.json())
      .then((result) => {
        toast.success("Password updated successfully");
        this.setState({ newPassword: "" });
      })
      .catch(() => {
        toast.error("Failed to update password");
      });
  };

  getRoles = () => {
    fetch(SERVER_URL + "/roles/getRoles", { method: "GET", headers: getAuthHeaders(), redirect: "follow" })
      .then((res) => res.json())
      .then((result) => {
        if (result.success && result.roles) {
          const map = {};
          result.roles.forEach((item) => {
            map[getEntityId(item)] = item.name;
          });
          this.setState({ idRoleMap: map });
        }
      })
      .catch(() => {});
  };

  getTabsByRole = (roleId) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const authHeaders = getAuthHeaders();
    if (authHeaders.Authorization) myHeaders.append("Authorization", authHeaders.Authorization);
    fetch(SERVER_URL + "/tabs/getTabsByRole", {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ role: roleId }),
      redirect: "follow",
    })
      .then((res) => res.json())
      .then((result) => this.setState({ tabs: result.tabs || [] }))
      .catch(() => {});
  };

  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  componentDidMount() {
    const userStr = localStorage.getItem("user");
    if (!userStr) {
      window.location = "/login";
      return;
    }
    const user = JSON.parse(userStr);
    this.setState({ user });
    this.getRoles();
    this.getTabsByRole(getUserRoleId({ user }));
  }

  render() {
    return (
      <div className="app-layout">
        <Sidebar
          tabs={this.state.tabs}
          user={this.state.user}
          idRoleMap={this.state.idRoleMap}
        />
        <div className="main-content-wrapper">
          <div className="reset-password-page">
            <div className="reset-password-scroll">
              <div className="reset-password-inner">
                <div className="reset-password-card">
                  <h1 className="reset-password-title">Reset password</h1>
                  <p className="reset-password-subtitle">Choose a strong password that meets the criteria below.</p>

                  <div className="reset-password-requirements">
                    <span className="reset-password-requirements-title">Password must contain:</span>
                    <ul>
                      <li>One uppercase letter</li>
                      <li>One lowercase letter</li>
                      <li>One digit</li>
                      <li>One special character (!@#$%^&* etc.)</li>
                      <li>At least 8 characters</li>
                    </ul>
                  </div>

                  <div className="reset-password-form">
                    <label htmlFor="newPassword" className="reset-password-label">
                      New password
                    </label>
                    <Input
                      id="newPassword"
                      name="newPassword"
                      type="password"
                      className="reset-password-input"
                      value={this.state.newPassword}
                      onChange={this.handleInputChange}
                      placeholder="Enter new password"
                      autoComplete="new-password"
                    />
                    <button
                      type="button"
                      className="reset-password-btn"
                      onClick={this.submitResetPassword}
                    >
                      Update password
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPasswordComponent;
